// extracted by mini-css-extract-plugin
module.exports =  {"common-link-error":"saveFileSelect__common-link-error","list":"saveFileSelect__list"};